import * as FiIcons from 'react-icons/fi';

export const benefits = [
  [FiIcons.FiClock, 'Available when you need it', 'A consistent coaching space available across mobile and desktop.'],
  [FiIcons.FiUser, 'Personalised conversations', 'Reflect on your goals, challenges and progress in your own context.'],
  [FiIcons.FiTarget, 'Structured progress', 'Turn ideas into practical goals, habits and accountable next steps.'],
  [FiIcons.FiTrendingUp, 'Continuous improvement', 'Build momentum through regular reflection and focused development.'],
  [FiIcons.FiLock, 'Confidential personal space', 'Commercial account data is kept separate from coaching conversations where possible.'],
  [FiIcons.FiBriefcase, 'Professional development', 'Strengthen leadership, communication, confidence and career effectiveness.']
];

export const coachingAreas = [
  'Leadership', 'Career Development', 'Personal Productivity', 'Communication',
  'Goal Setting', 'Confidence', 'Team Leadership', 'Decision Making',
  'Work Life Effectiveness', 'Professional Growth'
];

export const faqs = [
  ['What is AI coaching?', 'AI coaching is a structured digital experience that supports reflection, goal setting and professional development.'],
  ['Who is this service for?', 'It is designed for individuals, leaders, employees, coaches, universities and development programmes.'],
  ['Is coaching available at any time?', 'The coaching platform is generally accessible around the clock, subject to platform availability and maintenance.'],
  ['Can I cancel?', 'Yes. You can cancel future renewal and normally retain access until the end of your paid period.'],
  ['Can organisations purchase licences?', 'Yes. We support centralised billing, onboarding and volume licence arrangements.'],
  ['Is my information private?', 'We collect only the information needed to operate the service. Review the Privacy Policy for details.'],
  ['Does AI coaching replace a human coach?', 'No. It complements development activity and does not replace professional, clinical or regulated advice.'],
  ['What happens after payment?', 'Your subscription is confirmed and placed in awaiting allocation while your coaching access is prepared.'],
  ['How long does activation take?', 'Activation timing is shown during checkout and confirmed by email when your access is ready.'],
  ['What devices can I use?', 'The customer portal and coaching experience support modern desktop, tablet and mobile browsers.']
];

export const fallbackPlans = [
  {
    id: 'monthly-demo',
    name: 'Monthly',
    description: 'Flexible coaching access billed monthly.',
    currency: 'AED',
    price_amount: '[PRICE]',
    interval: 'month',
    features: ['Full AI coaching access', 'Personalised coaching', 'Goal setting', 'Progress tracking', 'Mobile access', 'Cancel future renewal at any time']
  },
  {
    id: 'annual-demo',
    name: 'Annual',
    description: 'A full year of focused development.',
    currency: 'AED',
    price_amount: '[PRICE]',
    interval: 'year',
    featured: true,
    features: ['Everything in Monthly', 'Effective monthly saving', 'Annual billing', 'Continuous development']
  },
  {
    id: 'corporate-demo',
    name: 'Corporate',
    description: 'Flexible programmes for organisations.',
    currency: 'AED',
    price_amount: null,
    interval: 'contract',
    features: ['Multiple user licences', 'Leadership programmes', 'Centralised billing', 'Dedicated support', 'Volume pricing', 'Corporate onboarding']
  }
];